
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/trend-spotter",
      function () {
        return require("private-next-pages/tools/trend-spotter/index.tsx");
      }
    ]);
  